/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Theme, useTheme, VFlow } from 'bold-ui'
import { useMedicamentoUsoModalQuery } from 'graphql/hooks.generated'
import { ReceitaMedicamento } from 'graphql/types.generated'
import { Fragment } from 'react'
import { isEmpty } from 'util/validation/Util'
import { AccordionCardSection } from 'view/atendimentos/detail/soap/aside/components/AccordionCardSection'

import { AcompanhamentoCard } from '../../components/AcompanhamentoCard'
import { MedicamentoEmUsoRow } from './MedicamentoEmUsoRow'

interface MedicamentosEmUsoCardProps {
  prontuarioId: ID
}

export function MedicamentosEmUsoCard(props: MedicamentosEmUsoCardProps) {
  const { prontuarioId } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const {
    data: { listaMedicamento: medicamentos },
    loading,
  } = useMedicamentoUsoModalQuery({
    variables: {
      input: { prontuarioId, ativo: true, isAcompanhamentoPreNatal: true, pageParams: { unpaged: true } },
    },
    skip: !prontuarioId,
  })

  const medicamentosToShow = medicamentos?.content?.slice(0, 3)
  const medicamentosAccordion = medicamentos?.content?.slice(3)
  const hasMedicamentosToShow = !isEmpty(medicamentosToShow)

  const renderMedicamentoRow = (index: number, receita: ReceitaMedicamento) => {
    return (
      <Fragment>
        {!!index && <hr css={styles.divider} />}
        <MedicamentoEmUsoRow prontuarioId={prontuarioId} receita={receita} />
      </Fragment>
    )
  }

  return (
    <AcompanhamentoCard
      id='medicamentos-em-uso'
      title='Medicamentos em uso'
      placeholder='Nenhum medicamento em uso'
      bodyPadding={hasMedicamentosToShow ? '0' : undefined}
      loading={loading}
    >
      {hasMedicamentosToShow && (
        <VFlow vSpacing={0}>
          {medicamentosToShow?.map((receita, index) => renderMedicamentoRow(index, receita as ReceitaMedicamento))}
          {!isEmpty(medicamentosAccordion) && (
            <AccordionCardSection
              id='medicamentos-em-uso-accordion'
              contentPadding='0'
              title={{
                closed: `Mostrar +${'medicamento'.pluralizeAndConcatValue(medicamentosAccordion.length)}`,
                open: `Esconder medicamento${medicamentosAccordion.length > 1 ? 's' : ''}`,
              }}
            >
              {medicamentosAccordion.map((receita, index) =>
                renderMedicamentoRow(index, receita as ReceitaMedicamento)
              )}
            </AccordionCardSection>
          )}
        </VFlow>
      )}
    </AcompanhamentoCard>
  )
}

const createStyles = (theme: Theme) => ({
  divider: css`
    margin: 0;
    background-color: ${theme.pallete.divider};
  `,
})
